import axios from 'axios';  
import TokenService from "../Services/Token.service";
const API_URL =  process.env.REACT_APP_API_URL ;  

// Login function
export const login = async(formData) => {
  return axios.post(`${API_URL}/auth/login`, formData)
    .then(response => response.data)
    .catch(error => {
      throw error;
    });
};

// resend otp function
export const resendOTP = async(formData) => {
  return axios.post(`${API_URL}/auth/resendotp`, formData)
    .then(response => response.data)
    .catch(error => {
      throw error;
    });
};


// Signup function
export const signup =async(signupData) => {
  return fetch(`${API_URL}/auth/donor-register`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(signupData),
  })
  .then(response => {
    if (!response.ok) {
      throw new Error(`Error: ${response.status} - ${response.statusText}`);
    }
    return response.json();
  })
  .then(data => data)
  .catch(error => {
    throw error;
  });
};

// Forgot password function
export const forgotPassword =async (email) => {
  return axios.post(`${API_URL}/auth/forgot-password`, { email })
    .then(response => response.data)
    .catch(error => {
      throw error;
    });
};

// Reset password function
export const resetPassword = async(token, password, confirmPassword) => {
  return axios.post(`${API_URL}/auth/reset-password`, {
    token,
    password,
    confirm_password: confirmPassword,
  })
  .then(response => response.data)
  .catch(error => {
    throw error;
  });
};

export const resetPasswordVerify = async(token) => {
  return axios.post(`${API_URL}/auth/reset-password-token/verify`, {
    token
  })
  .then(response => response.data)
  .catch(error => {
    throw error;
  });
};

// Logout
export const logout = async () => {
  try { 
      const user_id = TokenService.getUserId() || 0;     
      const response = await axios.post(`${API_URL}/auth/logout`, {user_id});
      return response.data;  
  } catch (error) {
      throw error;
  }
};